import { TextField, Tooltip } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

import { IQuestionnaireFormWidgetProps } from 'src/features/questionnaire/domain/types';
import { parseDateValue } from 'src/utils/dateUtils';

import { getWidgetLabel } from './DateTimePickerWidget';

const DatePickerWidget: React.FC<IQuestionnaireFormWidgetProps> = ({
	question,
	onValueChange,
	isDisabled,
	error,
	helperText = 'This field is invalid',
	compactMode = false,
}) => {
	const rawValue = question.submitted_data?.value_date ?? null;

	const value = parseDateValue(rawValue);

	const handleDateChange = (newValue: Date | null) => {
		if (newValue instanceof Date && !isNaN(newValue.getTime())) {
			onValueChange(
				question,
				newValue.toISOString().split('T')[0],
				'value_date',
			);
		} else {
			onValueChange(question, null, 'value_date');
		}
	};

	const getToolTipTitle = () => {
		return (
			<span style={{ whiteSpace: 'pre-line' }}>
				Q: {question.text}
				{value ? `\n\nAns: ${value.toLocaleDateString()}` : ''}
			</span>
		);
	};

	return (
		<DatePicker
			label={getWidgetLabel(question, compactMode)}
			value={value}
			disabled={isDisabled}
			sx={{ width: '100%' }}
			onChange={handleDateChange}
			slots={{
				textField: (params) => (
					<Tooltip
						title={getToolTipTitle()}
						arrow
						placement='left-start'
					>
						<TextField
							{...params}
							fullWidth
							error={error}
							helperText={error ? helperText : ''}
							disabled={isDisabled}
							sx={{
								width: '100%',
								'& input': {
									textOverflow: 'ellipsis',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
								},
							}}
						/>
					</Tooltip>
				),
			}}
		/>
	);
};

export default DatePickerWidget;
